import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core'; 
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MenuService } from 'src/app/services/menu/menu.service';

@Component({
  selector: 'app-menu-item-edit-modal',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './menu-item-edit-modal.component.html',
  styleUrl: './menu-item-edit-modal.component.css'
})
export class MenuItemEditModalComponent implements OnInit {

  @Input() menuItem: any;
  menuItemTitle: string = '';
  menuItemVisibility: number = 1;
  load = false

  constructor(public activeModal: NgbActiveModal, private MenuService: MenuService, private ToastrService: ToastrService) {}

  ngOnInit(): void {
    if (this.menuItem) {
      this.menuItemTitle = this.menuItem.menutitle;
      this.menuItemVisibility = this.menuItem.visibility;
    }
  }

  saveChanges(): void {
    this.load = true
    this.menuItem.menutitle = this.menuItemTitle;
    this.menuItem.visibility = this.menuItemVisibility;

    const updatedData = {
      idx: this.menuItem.idx,
      id: this.menuItem.id,
      menutitle: this.menuItemTitle,
      visibility: this.menuItemVisibility
    };

    this.MenuService.updateMenuItem(updatedData).subscribe(
      (res: any) => {
        this.load = false
        this.activeModal.close(updatedData);
        // this.activeModal.close(this.menuItem);
        this.ToastrService.success('შენახულია')
        console.log(res)
      },
      (error: any) => {
        this.load = false
        this.ToastrService.error('შეცდომა')
        console.log(error)
      }
    );

    
  }
}